/*
 * Copyright Huesik (c) 2019.
 */

export default {
  autoHypenPhone(str) {
    if (!str) {
      return ''
    }
    let tmp = ''
    tmp += str.substr(0, 4)

    tmp += '-'
    tmp += str.substr(4, 4)
    tmp += '-'
    tmp += str.substr(8)
    return tmp
  },
  isSmallScreen () {
    return window.matchMedia('screen and (max-width:768px)').matches
  },
  isMediumScreen () {
    return window.matchMedia('screen and (max-width:1366px)').matches
  },
  isiPad () {
    return window.matchMedia('screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio: 1)').matches
  }
}
